export const POSTHOG_KEY = process.env.BUN_PUBLIC_POSTHOG_KEY
export const SUPPORT_PHONE = process.env.BUN_PUBLIC_SUPPORT_PHONE
export const TELEVET_PHONE =
  process.env.BUN_PUBLIC_TELEVET_PHONE ?? '+18447380159'
